import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DescriptionContentSynopsis = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  display: -webkit-box;
  font-family: ${Fonts['regular']};
  font-size: ${32 * Screen.widthRatio}px;
  height: ${115 * Screen.widthRatio}px;
  margin-top: ${Screen.widthRatio * 26}px;
  overflow: hidden;
  width: ${843 * Screen.widthRatio}px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;

export default DescriptionContentSynopsis;
